/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FloorplanHeatmapData,
    FloorplanHeatmapDataFromJSON,
    FloorplanHeatmapDataFromJSONTyped,
    FloorplanHeatmapDataToJSON,
} from './FloorplanHeatmapData';

/**
 * 
 * @export
 * @interface FloorplanHeatmapListResponse
 */
export interface FloorplanHeatmapListResponse {
    /**
     * 
     * @type {Array<FloorplanHeatmapData>}
     * @memberof FloorplanHeatmapListResponse
     */
    heatmaps: Array<FloorplanHeatmapData>;
}

export function FloorplanHeatmapListResponseFromJSON(json: any): FloorplanHeatmapListResponse {
    return FloorplanHeatmapListResponseFromJSONTyped(json, false);
}

export function FloorplanHeatmapListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FloorplanHeatmapListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'heatmaps': ((json['heatmaps'] as Array<any>).map(FloorplanHeatmapDataFromJSON)),
    };
}

export function FloorplanHeatmapListResponseToJSON(value?: FloorplanHeatmapListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'heatmaps': ((value.heatmaps as Array<any>).map(FloorplanHeatmapDataToJSON)),
    };
}

